// The API answers every failure with HTTP 400 and a body of
// { statusCode, errorMessage, errorCode? }. errorCode is what to branch on -
// message copy changes, codes do not.

export function getErrorMessage(error, fallback) {
  if (error && error.response && error.response.data) {
    if (error.response.data.errorMessage) {
      return error.response.data.errorMessage;
    }
    return fallback;
  }
  // No response at all: the request never reached the server.
  return "Unable to reach the server. Please check your connection and try again.";
}

export function getErrorCode(error) {
  if (error && error.response && error.response.data) {
    return error.response.data.errorCode || null;
  }
  return null;
}
